import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { registerServiceWorker } from "./sw-registration.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("未找到 #root 挂载节点");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
